import { getColor } from "../typography/shared.js";
import checkbox_module_default from "./checkbox.module.js";
import { Checkbox, CheckboxGroup } from "@mantine/core";
import { useCallback } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/checkbox/Checkbox.tsx
const Checkbox$1 = (() => {
	const Component = ({ label, error, indeterminate, description, disabled, onBlur, onChange, onFocus, checked, value, highContrast, color = "primary", size, "aria-label": ariaLabel, "data-testid": testId }) => {
		const handleChange = useCallback((e) => onChange?.(e.currentTarget.checked), [onChange]);
		return /* @__PURE__ */ jsx(Checkbox, {
			color: getColor(color, highContrast),
			label,
			radius: "xxs",
			classNames: checkbox_module_default,
			indeterminate,
			description,
			error,
			disabled,
			onBlur,
			onChange: handleChange,
			checked,
			onFocus,
			value,
			size,
			"aria-label": ariaLabel,
			"data-testid": testId
		});
	};
	Component.Group = CheckboxGroup;
	return Component;
})();

//#endregion
export { Checkbox$1 as Checkbox };